import React from 'react';
import { ListItemButton, Skeleton } from '@mui/material';

const SessionItemSkeleton = () => {
  return (
    <ListItemButton
      style={{ height: '100px' }}  // Establece la altura fija que desees
    >
      <Skeleton variant="rect" width="100%" height="100%" animation="wave" />
    </ListItemButton>
  );
};

export default SessionItemSkeleton;